import create from "zustand";
import { immerMiddleware } from "./immer-helper";

interface IPipelineStore {
    pipeline: PipelineJson;
    setPipeline: (pipeline: PipelineJson) => void;
    updatePipeline: (prop: string, value: any) => void;
    setStepPosition: (
        stepId: string,
        position: { x: number; y: number }
    ) => void;

    updateStep: (
        stepId: string,
        prop: string,
        value: any,
        path?: "editorSettings"
    ) => void;
    updateVar: (varId: string, prop: string, value: any) => void;
}

const usePipelineStore = create<IPipelineStore>(
    immerMiddleware((set, get) => ({
        pipeline: {
            editorSettings: {
                stepIds: [],
                varsOrder: [],
                debugInstancesIds: [],
            },
            name: "",
            firstStepId: "",
            steps: {},
            vars: {},
        },
        setPipeline: (pipeline) => {
            set((state) => {
                state.pipeline = pipeline;
            });
        },
        setStepPosition: (stepId, position) => {
            const state = get();

            // let zIndex = state.pipeline.steps[stepId].editorSettings.zIndex;
            // Object.keys(state.pipeline.steps).forEach((key) => {
            // 	if (key != stepId && state.pipeline.steps[key].editorSettings.zIndex >= zIndex) {
            // 		zIndex = state.pipeline.steps[key].editorSettings.zIndex + 1;
            // 	}
            // });

            set((state) => {
                state.pipeline.steps[stepId].editorSettings.position = position;
                // state.pipeline.steps[stepId].editorSettings.zIndex = zIndex;
            });
        },
        updatePipeline: (prop, value) => {
            set((state) => {
                (state.pipeline as any)[prop] = value;
            });
        },
        updateStep: (stepId, prop, value, path) => {
            set((state) => {
                if (path) {
                    (state.pipeline.steps[stepId][path] as any)[prop] = value;
                } else {
                    (state.pipeline.steps[stepId] as any)[prop] = value;
                }
            });
        },
        updateVar: (varId, prop, value) => {
            set((state) => {
                // (state.pipeline.steps[stepId] as any)[prop] = value;
            });
        },
    }))
);

export default usePipelineStore;
